import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';

import { ApiService } from 'src/app/infrastructure/services/api-service/api.service';
import { components } from 'src/assets/api/schema';
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';
import { modelResolve$ } from 'src/app/infrastructure/functions/model-resolve.function';
import { routePage } from 'src/app/infrastructure/services/route-service/models/route-page';

type UserDto = components['schemas']['UserDto'];

export const accountModelResolver: ResolveFn<UserDto | undefined> = (_route: ActivatedRouteSnapshot) => {
    const __apiService = injectRequired(ApiService);

    return modelResolve$(__apiService.GET('/api/Account/details', {}), `/${routePage.login}`);
};
